import React from "react";
import AddProductForm from "./AddProductForm";
import AddIcon from "@mui/icons-material/Add";
import { Link } from "react-router";
import ImportProduct from "./ImportProduct";

function AddProducts() {
  return (
    <div className="   flex flex-col lg:overflow-y-hidden ">
      {/* Header */}
      <div className="flex flex-col lg:flex-row justify-between mb-6 items-center w-full">
        <div className="flex items-center">
          <AddIcon />
          <h3 className="text-xl font-semibold">Add New Product</h3>
        </div>

        <div className="flex gap-6">
          <ImportProduct />
          <Link
            to="../products"
            className="p-4 bg-blue-500 rounded-lg text-white"
          >
            Product List
          </Link>
        </div>
      </div>

      <div className=" bg-white rounded-lg flex flex-col  w-full lg:gap-8 flex-grow items-center p-6">
        <div>
          <h3 className="text-2xl font-semibold">Product Details</h3>
        </div>
        <AddProductForm />
      </div>
    </div>
  );
}

export default AddProducts;
